<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3>
          <i class="fas fa-bullseye mr-2"></i>
          Metas
        </h3>
      </div>
    </div>
    <MetasAdd
      v-if="showAdd"
      :editingManager="clickedManager"
      :editingManagerPeriodicity="clickedManagerPeriodicity"
      :editingManagerReferencePeriod="clickedManagerReferencePeriod"
      v-on:Back="onBack"
    />
    <MetasList v-else v-on:New="onNewGoal" v-on:Edit="onEditGoal" />
  </div>
</template>
<script>
import MetasAdd from './add/MetasAdd.vue'
import MetasList from './list/MetasList.vue'
import { ListGoalPeriods } from '@/enums/enumGoalMetricTypes.js'

export default {
  name: 'MetasGerente',
  data () {
    return {
      showAdd: false,
      clickedManager: null,
      clickedManagerPeriodicity: null,
      clickedManagerReferencePeriod: null,
      listGoalPeriods: ListGoalPeriods
    }
  },
  components: {
    MetasAdd,
    MetasList
  },
  methods: {
    onNewGoal () {
      this.showAdd = true
    },
    onEditGoal (account) {
      this.clickedManagerPeriodicity = ListGoalPeriods[account.periodicidade]
      this.clickedManagerReferencePeriod = account.referenciaPeriodo
      this.clickedManager = {
        text: account.gerenteCarteira.funcionario.pessoa.nome,
        value: account.gerenteCarteira.id
      }
      this.$nextTick(() => {
        this.showAdd = true
      })
    },
    onBack () {
      this.showAdd = false
      this.clickedManager = null
      this.clickedManagerPeriodicity = null
      this.clickedManagerReferencePeriod = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/metas-gerente/MetasGerente.vue